import React, { useState, useCallback } from "react";
import { Grid, FormControl, Input, InputLabel, Select, MenuItem, Button, makeStyles } from "@material-ui/core";
import { debounce } from '../utils/debounce';
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    paddRight: {
        [theme.breakpoints.up('sm')]: {
            paddingRight: theme.spacing(3),
        },
    },
    paddBottom: {
        paddingBottom: theme.spacing(3),
    },
    resetButtonStyles: {
        marginTop: '16px',
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
        },
    },
    flexItem: {
        flex: '0 1 100%',

        [theme.breakpoints.up('sm')]: {
            flex: 1,
        },
    },
}));

function Form({state, setState, constants}) {
    const classes = useStyles();
    const [searchText, setSearchText] = useState(state.searchString);

    const handler = useCallback(debounce(val => setState({ ...state, pageIndex: 0, searchString: val }), 500), [state]);
    const onSearchChange = event => {
        const value = event.target.value;

        setSearchText(value);
        handler(value);
    };

    const handleReset = () => {
        setState({
            ...state,
            pageIndex: 0,
            searchString: '',
            category: 'all',
            source: 'all',
            year: 'all'
        });

        setSearchText('');
    }

    const handleOnYearChange = e => {
        let startDate = null;
        let endDate = null;

        if (e.target.value !== 'all') {
            startDate = moment(`${constants.years[e.target.value]}-${constants.startDateSuffix}`);
            endDate = moment(`${constants.years[e.target.value]}-${constants.endDateSuffix}`);
        }

        setState({ ...state, pageIndex: 0, startDate: startDate, endDate: endDate, year: e.target.value });
    };

    return (
        <form>
            <Grid container>
                <Grid className={`${classes.paddBottom} ${classes.flexItem} ${classes.paddRight}`} item>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="search">Search</InputLabel>
                        <Input id="search" value={searchText} onChange={e => onSearchChange(e)} />
                    </FormControl>
                </Grid>

                <Grid item className={`${classes.paddRight} ${classes.paddBottom} ${classes.flexItem}`}>
                    <FormControl fullWidth>
                        <InputLabel id="select-label">Category</InputLabel>
                        <Select labelId="select-label" id="select" value={state.category} onChange={e => setState({ ...state, pageIndex: 0, category: e.target.value })}>
                            <MenuItem key="all" value="all">All</MenuItem>
                            {constants.initialCategories.map((obj, i) => (
                                <MenuItem key={i} value={i}>{obj.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item className={`${classes.flexItem} ${classes.paddRight}`}>
                    <FormControl fullWidth>
                        <InputLabel id="select-label">Year</InputLabel>
                        <Select labelId="select-label" id="select-year" value={state.year} onChange={e => handleOnYearChange(e)}>
                            <MenuItem key="all" value="all">All</MenuItem>
                            {constants.years.map((obj, i) => (
                                <MenuItem key={i} value={i}>{obj}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item className={classes.paddBottom}>
                    <Button className={classes.resetButtonStyles} onClick={ handleReset } variant="contained">Reset</Button>
                </Grid>
            </Grid>
        </form>
    );
}

export default Form;
